import { render, staticRenderFns } from "./ZinusQuickMenu.vue?vue&type=template&id=4d6ccee6"
import script from "./ZinusQuickMenu.ts?vue&type=script&lang=ts&external"
export * from "./ZinusQuickMenu.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports